/*!
 * Remedy Distillery - Big Thirst Storefront Config
 *
 * Shared Daisy / checkout-6 storefront setup.
 *
 * Recommended install after upload to checkout-6 Shopify Content > Files:
 *   Global site header:
 *   <script src="https://checkout-6.bigthirst.com/cdn/shop/files/remedy-storefront-config.js"></script>
 *
 *   Shop page:
 *   <div id="bt-collection" style="min-height: 120px;">Loading products...</div>
 */

window.__BT_REMEDY_STOREFRONT_CONFIG_VERSION = '2026-04-28-01';
console.info('[Remedy Storefront Config]', window.__BT_REMEDY_STOREFRONT_CONFIG_VERSION);

window.BigThirstCartConfig = {
  domain: 'checkout-6.bigthirst.com',
  apiVersion: '2026-01',

  // Collection
  collectionHandle: 'remedy-distillery-all-bottles',

  // Tracking
  ga4Id: 'G-EYD533NBCF',

  // Buttons
  buyButtonText: 'Add to Cart',
  checkoutButtonText: 'Begin Checkout',

  // Inventory display
  showInventory: true,
  inventoryThreshold: 10,
  inventoryInStockText: 'In Stock',
  inventorySoldOutText: 'Sold Out',

  // Cart copy
  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax, shipping, and promo codes are handled in the next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: '',
  cartNoteLabel: 'Order Note or Personalized Note for Recipient',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  // "Playful Display" is listed first for client-side/custom-font availability.
  // Google Fonts does not currently serve that family, so Playfair Display is the hosted fallback.
  googleFonts: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400&family=Montserrat:wght@400;600;700&display=swap',

  cssVars: [
    '--bt-font: "Playful Display", "Playfair Display", Georgia, serif;',
    '--bt-alt-font: "Montserrat", Arial, sans-serif;',
    '--bt-text-color: #000000;',
    '--bt-price-color: #123427;',
    '--bt-price-size: 18px;',
    '--bt-title-size: 27px;',
    '--bt-title-weight: 400;',
    '--bt-title-margin: 10px;',
    '--bt-title-min-height: 64px;',
    '--bt-description-size: 15px;',
    '--bt-border-color: #123427;',
    '--bt-btn-bg: #4a2652;',
    '--bt-btn-color: #ffffff;',
    '--bt-btn-hover-bg: #123427;',
    '--bt-btn-hover-color: #ffffff;',
    '--bt-btn-px: 24px;',
    '--bt-btn-radius: 2px;',
    '--bt-grid-gap: 28px;',
    '--bt-grid-bottom: 28px;',
    '--bt-img-max-height: 360px;',
    '--bt-toggle-icon-color: #ffffff;',
    '--bt-toggle-count-color: #ffffff;',
    '--bt-inventory-color: #123427;',
    '--bt-inventory-low-color: #b65e0c;',
    '--bt-notice-bold-color: #000000;',
    '--bt-notice-link-color: #4a2652;',
  ].join(' '),

  customCSS: [
    '#bt-collection {',
    '  box-sizing: border-box;',
    '  width: min(1180px, calc(100vw - 32px));',
    '  margin: 0 auto;',
    '  padding: clamp(28px, 4vw, 54px);',
    '  background: #f4f4f4;',
    '  color: #000000;',
    '  font-family: "Montserrat", Arial, sans-serif;',
    '}',
    '#bt-collection, #bt-collection * { box-sizing: border-box; }',
    '#bt-collection .bt-products {',
    '  display: grid !important;',
    '  grid-template-columns: repeat(3, minmax(0, 1fr));',
    '  gap: 34px 28px;',
    '  margin-left: 0 !important;',
    '}',
    '#bt-collection .bt-product {',
    '  width: auto !important;',
    '  margin: 0 !important;',
    '  min-width: 0;',
    '  padding: 26px 22px 24px;',
    '  background: #ffffff;',
    '  border: 1px solid rgba(18, 52, 39, 0.22);',
    '  border-top: 5px solid #123427;',
    '  text-align: center;',
    '  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.07);',
    '}',
    '#bt-collection .bt-product:nth-child(2n) { border-top-color: #4a2652; }',
    '#bt-collection .bt-product:nth-child(3n) { border-top-color: #b65e0c; }',
    '#bt-collection .bt-product img {',
    '  width: 100%;',
    '  max-height: 360px;',
    '  margin: 0 auto 20px;',
    '  object-fit: contain;',
    '}',
    '#bt-collection .bt-product-title {',
    '  font-family: "Playful Display", "Playfair Display", Georgia, serif !important;',
    '  font-weight: 400 !important;',
    '  line-height: 1.05;',
    '  letter-spacing: 0;',
    '  color: #000000 !important;',
    '}',
    '#bt-collection .bt-product-price {',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '  font-size: 18px !important;',
    '  font-weight: 700 !important;',
    '  color: #123427 !important;',
    '  margin-bottom: 12px;',
    '}',
    '#bt-collection .bt-product-description {',
    '  flex: 1;',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '  font-size: 15px !important;',
    '  line-height: 1.55;',
    '  color: #000000 !important;',
    '  margin-bottom: 18px;',
    '  text-align: center;',
    '}',
    '#bt-collection .bt-product-description p { margin: 0 0 0.8em; }',
    '#bt-collection .bt-product-description p:last-child { margin-bottom: 0; }',
    '#bt-collection .bt-inventory {',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '  font-size: 12px;',
    '  font-weight: 700;',
    '  letter-spacing: 0.08em;',
    '  margin: 0 0 10px;',
    '  text-transform: uppercase;',
    '}',
    '#bt-collection .bt-variant-select {',
    '  min-height: 42px;',
    '  margin: 0 0 14px;',
    '  border: 1px solid rgba(18, 52, 39, 0.45) !important;',
    '  background: #ffffff;',
    '  color: #000000;',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '}',
    '#bt-collection .bt-qty-wrap, .bt-embed .bt-qty-wrap {',
    '  justify-content: center;',
    '  margin-bottom: 14px;',
    '}',
    '#bt-collection .bt-qty-btn, #bt-collection .bt-qty-input,',
    '.bt-embed .bt-qty-btn, .bt-embed .bt-qty-input,',
    '#bt-cart-drawer .bt-line-qty-btn, #bt-cart-drawer .bt-line-qty {',
    '  border-color: rgba(18, 52, 39, 0.45) !important;',
    '  color: #000000 !important;',
    '  background: #ffffff !important;',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '}',
    '#bt-collection .bt-qty-btn:hover, .bt-embed .bt-qty-btn:hover, #bt-cart-drawer .bt-line-qty-btn:hover {',
    '  background: rgba(18, 52, 39, 0.08) !important;',
    '}',
    '.bt-add-btn, .bt-checkout-btn {',
    '  background: #4a2652 !important;',
    '  color: #ffffff !important;',
    '  border: 1px solid #4a2652 !important;',
    '  border-radius: 2px !important;',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '  font-size: 14px !important;',
    '  font-weight: 700 !important;',
    '  letter-spacing: 0.08em;',
    '  line-height: 1.15;',
    '  min-height: 46px;',
    '  padding: 14px 18px !important;',
    '  text-transform: uppercase;',
    '  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease !important;',
    '}',
    '.bt-add-btn:hover, .bt-add-btn:focus, .bt-checkout-btn:hover, .bt-checkout-btn:focus {',
    '  background: #123427 !important;',
    '  border-color: #123427 !important;',
    '  color: #ffffff !important;',
    '  opacity: 1 !important;',
    '}',
    '.bt-add-btn:disabled { background: #000000 !important; border-color: #000000 !important; opacity: 0.45 !important; }',
    '#bt-cart-toggle {',
    '  right: 18px !important;',
    '  bottom: 18px !important;',
    '  min-width: 58px;',
    '  min-height: 52px;',
    '  background: #4a2652 !important;',
    '  border: 1px solid #4a2652 !important;',
    '  border-radius: 2px !important;',
    '  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.24) !important;',
    '}',
    '#bt-cart-toggle:hover, #bt-cart-toggle:focus { background: #123427 !important; border-color: #123427 !important; }',
    '#bt-cart-toggle svg, #bt-cart-toggle svg * { fill: #ffffff !important; stroke: #ffffff !important; }',
    '#bt-cart-count { color: #ffffff !important; font-family: "Montserrat", Arial, sans-serif !important; font-weight: 700; }',
    '#bt-cart-drawer {',
    '  background: #f4f4f4 !important;',
    '  color: #000000 !important;',
    '  font-family: "Montserrat", Arial, sans-serif !important;',
    '}',
    '#bt-cart-drawer .bt-cart-header { border-bottom-color: rgba(18, 52, 39, 0.2) !important; }',
    '#bt-cart-drawer .bt-cart-title {',
    '  font-family: "Playful Display", "Playfair Display", Georgia, serif !important;',
    '  font-size: 28px !important;',
    '  font-weight: 400 !important;',
    '  color: #000000 !important;',
    '}',
    '#bt-cart-drawer .bt-line-item {',
    '  display: grid !important;',
    '  grid-template-columns: 74px minmax(0, 1fr);',
    '  gap: 14px;',
    '  align-items: start;',
    '  margin-bottom: 18px !important;',
    '  padding-bottom: 18px !important;',
    '  border-bottom-color: rgba(18, 52, 39, 0.18) !important;',
    '}',
    '#bt-cart-drawer .bt-line-item img {',
    '  width: 74px !important;',
    '  height: 74px !important;',
    '  object-fit: cover;',
    '  background: #000000;',
    '  border: 1px solid rgba(18, 52, 39, 0.18);',
    '}',
    '#bt-cart-drawer .bt-line-item-info {',
    '  min-width: 0;',
    '  display: grid;',
    '  gap: 7px;',
    '}',
    '#bt-cart-drawer .bt-line-item-title, #bt-cart-drawer .bt-cart-subtotal, #bt-cart-drawer .bt-cart-empty { color: #000000 !important; }',
    '#bt-cart-drawer .bt-line-item-title { margin: 0 !important; line-height: 1.25; }',
    '#bt-cart-drawer .bt-line-item-price { color: #123427 !important; margin: 0 !important; }',
    '#bt-cart-drawer .bt-line-item-controls { display: flex !important; align-items: center; gap: 8px; margin-top: 2px !important; }',
    '#bt-cart-drawer .bt-line-qty-btn { width: 30px !important; height: 30px !important; }',
    '#bt-cart-drawer .bt-line-qty { width: 38px !important; height: 30px !important; line-height: 30px !important; }',
    '#bt-cart-drawer .bt-line-remove {',
    '  margin-left: 2px !important;',
    '  color: #4a2652 !important;',
    '  font-size: 10px !important;',
    '  font-weight: 700 !important;',
    '  letter-spacing: 0.08em;',
    '  text-decoration: none !important;',
    '  text-transform: uppercase;',
    '}',
    '#bt-cart-drawer .bt-line-remove:hover, #bt-cart-drawer .bt-line-remove:focus { color: #123427 !important; text-decoration: underline !important; }',
    '#bt-cart-drawer .bt-line-item-variant, #bt-cart-drawer .bt-cart-note-label, #bt-cart-drawer .bt-cart-note-sublabel, #bt-cart-drawer .bt-cart-notice { color: #000000 !important; }',
    '#bt-cart-drawer .bt-cart-note { border-color: rgba(18, 52, 39, 0.38) !important; background: #ffffff !important; color: #000000 !important; }',
    '#bt-cart-drawer .bt-cart-footer { border-top-color: rgba(18, 52, 39, 0.2) !important; }',
    '@media (max-width: 940px) {',
    '  #bt-collection .bt-products { grid-template-columns: repeat(2, minmax(0, 1fr)); }',
    '}',
    '@media (max-width: 640px) {',
    '  #bt-collection { width: min(100%, calc(100vw - 20px)); padding: 24px 14px; }',
    '  #bt-collection .bt-products { grid-template-columns: 1fr; gap: 22px; }',
    '  #bt-collection .bt-product { padding: 22px 18px; }',
    '  #bt-collection .bt-product-title { min-height: 0; font-size: 25px !important; }',
    '  #bt-cart-toggle { right: 12px !important; bottom: 12px !important; }',
    '}',
  ].join('\n'),
};

// Load the shared Daisy engine.
(function () {
  var s = document.createElement('script');
  s.src = 'https://checkout-6.bigthirst.com/cdn/shop/files/bigthirst-cart.js?v=2026-04-28-01';
  s.async = true;
  document.head.appendChild(s);
})();
